import React, { Fragment, useMemo } from "react";
import styled from "styled-components";
import { View, Text, Link, Divider } from "./components";
import { graphql, Query } from "react-apollo";
import { compose } from "recompose";
import tagAlbumsQuery from "./graphql/tagAlbumsQuery";
import albumQuery from "./graphql/albumQuery";
import tagsQuery from "./graphql/tagsQuery";
import Gallery from "./components/Gallery";
import historyLength from "./utilities/historyLength";
import professions from "./professions";
import ReactMarkdown from "react-markdown";
import ImageGrid from "./components/ImageGrid";
import { Flex, Box } from "./components";
import { useMedia } from "use-media";
import { getAlbumKeyValue } from "./helpers";
import { Get } from "react-axios";
import { Helmet } from "react-helmet";

const Container = styled(View)`
  display: block;
  @media (max-width: 760px) {
    flex-direction: column;
  }
`;
const Navigation = styled(View)`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
`;

const MaxWidth = styled(View)`
  position: relative;
  ${({ theme: { maxWidth } }) => maxWidth};
  display: flex;
  width: 100%;
`;

const BioText = styled(Text)`
  p {
    margin-bottom: 0;
  }
`;

const Bio = ({ artist, data, category, name, profession }) => {
  const isWide = useMedia({ minWidth: 620 });
  const bioAlbum =
    data.allAlbums && data.allAlbums.length > 0 && data.allAlbums[0];
  const instagram = bioAlbum && getAlbumKeyValue(bioAlbum, "instagram");
  const website = bioAlbum && getAlbumKeyValue(bioAlbum, "website");
  const album = bioAlbum;

  if (
    !data.loading &&
    data.allAlbums.length === 1 &&
    !data.allAlbums[0].description
  ) {
    return null;
  }
  if (!album) return null;
  return (
    <Container>
      <Helmet>
        <title>
          {name} - {profession} • House Of Orange Agency • Amsterdam
        </title>
        <meta
          name="og:title"
          content={`${name} • House Of Orange Agency • Amsterdam`}
        />
        <meta name="description" content={album?.description} />
        <meta name="og:description" content={album?.description} />
      </Helmet>
      <Divider mb={6} mt={6} />
      <Flex justify="space-between" column={!isWide}>
        <Flex column justify="space-between">
          <Text textStyle="headline">Biography</Text>

          <BioText
            textStyle="bread"
            style={{ maxWidth: "36em" }}
            mb={5}
            mr={[0, 2, 2]}
          >
            {!data.loading && album && (
              <ReactMarkdown source={album.description} />
            )}
          </BioText>
        </Flex>
        <View style={{ minWidth: isWide ? 400 : null }} mb={5} mt={1}>
          {album.slides.length > 1 ? (
            <ImageGrid
              slides={album.slides.slice(1, 10)}
              style={{ width: "100%" }}
            />
          ) : instagram ? (
            <Get
              url="https://some.whitespace.photos/instaa/"
              params={{ username: instagram }}
            >
              {(error, response, isLoading, makeRequest, axios) => {
                if (error) {
                  return <div></div>;
                } else if (isLoading) {
                  return <div></div>;
                } else if (response !== null && response.data.length > 0) {
                  const images = response.data.slice(0, 9).map((post) => ({
                    url: post.images.standard_resolution.url,
                    link: post.link,
                  }));

                  return (
                    <ImageGrid images={images} style={{ width: "100%" }} />
                  );
                }
                return <div></div>;
              }}
            </Get>
          ) : null}
        </View>
      </Flex>

      <Flex justify="space-between">
        {website ? (
          <Text>
            <Link as="a" href={website} target="_blank" invert>
              {website.split("//")[1]}
            </Link>
          </Text>
        ) : (
          <Text />
        )}
        {instagram && (
          <Text>
            <Link
              as="a"
              href={`https://www.instagram.com/${instagram}`}
              target="_blank"
              invert
            >
              Instagram: {instagram}
            </Link>
          </Text>
        )}
      </Flex>
    </Container>
  );
};

export default compose(
  graphql(albumQuery, {
    options: ({ artist }) => {
      return {
        fetchPolicy: "cache-and-network",
        variables: {
          user: process.env.REACT_APP_WHITESPACE_USER,
          slug: artist ? `${artist}-bio` : "notfound",
        },
      };
    },
  })
)(Bio);
